<template>
	<div>
        <el-form ref="form" :inline="true" :model="filters" size="small">
            <el-form-item label="搜索条件" prop="company">
                <el-input clearable v-model="filters.company" @change="searchPage"></el-input>
            </el-form-item>
<!--            <el-form-item label="联系人" prop="contact">-->
<!--                <el-input clearable v-model="filters.contact" @change="searchPage"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="国家" prop="country">
                <el-input clearable v-model="filters.country" @change="searchPage"></el-input>
            </el-form-item>
            <el-form-item label="客户类别" prop="customerTypeId">
                <el-select clearable size="small" filterable v-model="filters.customerTypeId " placeholder="请选择客户类别" @change="searchPage">
                    <el-option v-for="item in typeOption" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户等级" prop="levelId">
                <el-select clearable size="small" filterable v-model="filters.levelId" placeholder="请选择客户级别" @change="searchPage">
                    <el-option v-for="item in levelOption" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户来源" prop="customerSourceId">
                <el-select clearable size="small" filterable v-model="filters.customerSourceId" placeholder="请选择客户来源" @change="searchPage">
                    <el-option v-for="item in sourceOption" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="info" icon="el-icon-search" @click="searchPage()">搜索</el-button>
            </el-form-item>
        </el-form>
        
        <!--列表-->
        <el-table @sort-change="sortChange" :data="pageData" border v-loading="tLoading">
            <el-table-column prop="nbr" label="序号" width="60" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="levelName" label="客户等级"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerTypeName" label="客户类型"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="country" label="国家"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="company" min-width="150" label="公司名/公司类型"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="contact" label="主要联系人" min-width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerSourceName" label="客户来源"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="products" label="常采购产品/咨询产品"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="lastTrackTime" label="跟踪日期" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="email" label="邮箱" min-width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="whatsApp" label="WhatsApp"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="tel" label="电话/座机" min-width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="otherContact" label="其他联系方式" min-width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="communication" label="主要沟通方式"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="website" label="网址"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="companyEstablishTime" label="公司成立时间" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="annualPurchaseNumber" label="年采购次数" align="right"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="annualPurchaseAmount" label="年采购量" align="right"></el-table-column>
            <el-table-column label="操作" width="60" align="right" fixed="right">
                <template slot-scope="scope">
                    <el-button type="warning" title="选中" @click="$emit('material', scope.row)" size="mini">选中</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <div class="toolbar" style="text-align: right;">
            <el-pagination @current-change="handleCurrentChange" background :current-page="filters.pageIndex"  :page-size="filters.pageSize" layout="total, prev, pager, next" :total="totalNum"></el-pagination>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            pageUrl:'/customer/list/page',

            filters:{
                pageSize: 10,
                pageIndex: 1,
                company:'',
                contact:'',
                country:'',
                customerTypeId:'',
                levelId:'',
                customerSourceId:'',
            },
        };
    },
    computed:{
        ...mapGetters(['levelOption', 'typeOption', 'sourceOption'])
    },
    created() {
        this.getPage();
    }
};
</script>